// extracted by mini-css-extract-plugin
export default {"screen":"LoadingScreen_screen__y5zJ2","content":"LoadingScreen_content__WrKWh","spinner":"LoadingScreen_spinner__NEgyF","text":"LoadingScreen_text__ytIgi"};